type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/**
 * YouTube miniplayer (picture-in-picture) glyph — a rounded outer rectangle
 * with a smaller filled rectangle nested in the lower-right. Mirrors
 * YouTube's actual miniplayer button on the desktop watch page.
 */
const YouTubeMiniplayerIcon = (props: Props) => {
  const { width = '20', height = '16', strokeColor = '#ffffff' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      aria-hidden
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="14"
        rx="1.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        fill="none"
      />
      <rect x="9.5" y="7.5" width="8" height="6" rx="0.6" fill={strokeColor} />
    </svg>
  );
};

export default YouTubeMiniplayerIcon;
